import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import BillingPage from "@/pages/BillingPage";
import BillingSuccess from "@/pages/BillingSuccess";
import VerifyPage from "@/pages/VerifyPage";
import SettingsPage from "@/pages/SettingsPage";
import AdminPage from "@/pages/AdminPage";

function RequireAuth({ children, requireOnboarded = true }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2]" data-testid="auth-loading">
        <span className="font-serif italic text-2xl text-[#913831]">rendezvous</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}

function RedirectIfAuthed({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && user.onboarded) return <Navigate to="/app" replace />;
  if (user && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RedirectIfAuthed><Landing /></RedirectIfAuthed>} />
            <Route path="/auth" element={<RedirectIfAuthed><AuthPage /></RedirectIfAuthed>} />
            <Route path="/onboarding" element={
              <RequireAuth requireOnboarded={false}><Onboarding /></RequireAuth>
            } />
            <Route path="/app" element={<RequireAuth><Home /></RequireAuth>} />
            <Route path="/billing" element={<RequireAuth><BillingPage /></RequireAuth>} />
            <Route path="/billing/success" element={<RequireAuth><BillingSuccess /></RequireAuth>} />
            <Route path="/verify" element={
              <RequireAuth requireOnboarded={false}><VerifyPage /></RequireAuth>
            } />
            <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
            <Route path="/admin" element={<RequireAuth requireOnboarded={false}><AdminPage /></RequireAuth>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
